import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useMutableRef } from '@carnica/utils/hooks';
import { useEffect, useRef, useState } from 'react';
export var useGetHeaderHeight = function useGetHeaderHeight() {
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    height = _useState2[0],
    setHeight = _useState2[1];
  var heightRef = useMutableRef(height);
  var resizingDelayTimer = useRef();
  useEffect(function () {
    var headerElement = document.querySelector('[data-component="site-header-container"]');
    var observer = new ResizeObserver(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        entry = _ref2[0];
      setHeight(entry.contentRect.height);
      clearTimeout(resizingDelayTimer.current);
      resizingDelayTimer.current = setTimeout(function () {
        if (heightRef.current !== entry.contentRect.height) {
          setHeight(height);
        }
      }, 100);
    });
    if (headerElement) {
      observer.observe(headerElement);
    }
    return function () {
      clearTimeout(resizingDelayTimer.current);
      if (headerElement) {
        observer.unobserve(headerElement);
      }
    };
  }, []);
  return height;
};